import React, {useContext, useEffect, useRef, useState} from 'react';
import {Copy, Mail} from "react-feather";
import ViewReviewModal from "./ViewReviewModal";
import Modal from "react-modal";
import {
    vendorClientReviewPatchUpdate,
    vendorGetClientReviews,
    vendorGetSingleClientReviewToken
} from "../../../services/api/clientReviews";
import MarketingWrap from "../../../components/Common/MarketingWrap";
import SuccessToaster from "../../../components/Toasters/SuccessToaster";
import ReviewsTable from "../../../components/ClientReviews/ReviewTable";
import {AuthContext} from "../../../context/AuthContext";

const invitationLink = `${window.location.origin}/public/marketing/leave-review/[token]`;

const ReviewsList = () => {
    const [selectedReview, setSelectedReview] = useState(null);
    const [openShareMode, setOpenShareModal] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tablePagination, setPagination] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [inviteToken, setToken] = useState(null);
    const shareMenuRef = useRef(null);
    const {company} = useContext(AuthContext);


    const getClientReviews = async () => {
        try {
            const {data, meta} = await vendorGetClientReviews(currentPage);
            setPagination(meta?.pagination);
            setTableData(data);
        } catch (e) {

        }
    }

    const updateDataFlag = (id, name, value, isSingle = false) => {
        const tempData = [...tableData];
        tempData.map(item => {
            if (item.id === id)
                item[name] = value;
            else if (isSingle)
                item[name] = false;
            return null;
        });
        setTableData(tempData);
    }

    const setReviewVisibility = async (id, value) => {
        try {
            updateDataFlag(id, 'visibility', value);
            await vendorClientReviewPatchUpdate(id, 'visibility', value)
            await getClientReviews();
        } catch (e) {

        }
    }

    const setFeaturedReview = async (id, value) => {
        try {
            updateDataFlag(id, 'featured', value, true);
            await vendorClientReviewPatchUpdate(id, 'featured', value, false)
            await getClientReviews();
        } catch (e) {

        }
    }

    const copyToken = async () => {
        try {
            setToken(null);
            const {token} = await vendorGetSingleClientReviewToken();
            const link = invitationLink.replace('[token]', token);
            const textField = document.createElement('textarea')
            textField.innerText = link;
            document.body.appendChild(textField)
            textField.select()
            document.execCommand('copy')
            textField.remove()

            setToken(token);
            setOpenShareModal(false);

        } catch (e) {

        }
    }

    const emailToken = async () => {
        try {
            const {token} = await vendorGetSingleClientReviewToken();
            const link = invitationLink.replace('[token]', token);

            const emailSubject = `Please provide a review for ${company.name}`;

            const emailBody = `Hi,  %0D%0A %0D%0A

${company.name} is using a tool called Shortlister to collect customer feedback and display those reviews to other prospective clients.
 I'd really appreciate it if you could 
take 2-3 minutes of your time, to provide a review. Please use the link below. 
%0D%0A %0D%0A 
${link}
 %0D%0A %0D%0A
To ensure reviews are genuine, Shortlister will ask you to authenticate via your LinkedIn credentials before leaving your review.
%0D%0A %0D%0A
Thanks in advance for your time and let us know if there is anything we can do to help you.`;


            setToken(null);

            window.location.href = `mailto:mail@gmail.com?subject=${emailSubject}&body=${emailBody}`;
            setOpenShareModal(false);

        } catch (e) {

        }
    }


    useEffect(() => {
            getClientReviews().catch(e => console.log(e));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [currentPage])

    useEffect(() => {
        function handleClickOutside(event) {
            if (shareMenuRef.current && !shareMenuRef.current.contains(event.target)) {
                setOpenShareModal(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [shareMenuRef]);

    return (
        <MarketingWrap>
            <div className="sl-my-32px sl-display-flex sl-text-left">
                <div className="sl-flex-col sl-flex sl-gap-2">
                    <span className="sl-text-gray-900 sl-font-semibold sl-text-xxl sl-font">Client Reviews</span>
                    <span className="sl-text-gray-700 sl-font-normal sl-text-sm sl-font">
                        Bolster your profile credibility through social proof to win more business. Easily
                        gather
                        client reviews on your Shortlister<br/> profile by providing them with this link. The
                        link is
                        unique to your organization and does not have to be unique to each<br/> client you send
                        it
                        to.
                    </span>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    {/*<a href={"#"}*/}
                    {/*   className="sl-font sl-font-medium sl-text-sm sl-text-primary-700 sl-cursor-pointer sl-no-underline">Detailed*/}
                    {/*    instructions <ArrowUpRight size={16}/></a>*/}
                </div>

                <div className="sl-m-auto sl-mr-0 sl-relative">
                    <button
                        onClick={() => setOpenShareModal(!openShareMode)}
                        className="sl-btn sl-btn-primary sl-btn-lg sl-shadow-xs sl-text-md sl-btn-icon-leading sl-h-10 sl-flex sl-align-center"
                    >Share invite link
                    </button>
                    <div ref={shareMenuRef}
                         className="sl-dropdown-menu sl-shadow-lg sl-max-w-64"
                         style={{display: openShareMode ? 'block' : 'none'}}>
                        <div className="sl-dropdown-header">
                            <label className="sl-avatar-label-group sl-flex sl-mb-0">
                                <div className="sl-flex sl-flex-col  sl-pl-1 sl-pt-6px sl-pb-6px sl-overflow-hidden"
                                     onClick={copyToken}>
                                        <span

                                            className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 sl-cursor-pointer sl-flex">
                                               <Copy size={20}
                                                     className="sl-cursor-pointer sl-text-gray-base sl-mr-2"/>
                                            Copy invite link
                                        </span>
                                </div>
                            </label>

                            <label
                                className="sl-avatar-label-group sl-flex sl-mb-0  sl-pr-14 sl-pt-10 sl-pb-10">
                                <div className="sl-flex sl-flex-col sl-pl-1 sl-pt-6px sl-overflow-hidden"
                                     onClick={emailToken}>
                                        <span
                                            className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 sl-cursor-pointer sl-flex">
                                               <Mail size={20}
                                                     className="sl-cursor-pointer sl-text-gray-base sl-mr-2"/>
                                            Email link
                                        </span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <ReviewsTable tableData={tableData}
                          setFeaturedReview={setFeaturedReview}
                          setSelectedReview={setSelectedReview}
                          setReviewVisibility={setReviewVisibility}
                          setCurrentPage={setCurrentPage}
                          tablePagination={tablePagination}
                          currentPage={currentPage
                          }/>

            {inviteToken && <SuccessToaster label={"Link copied to clipboard."}/>}


            <Modal
                isOpen={!!selectedReview}
                className="sl-modal-content sl-max-modal sl-max-w-860px"
                overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
                <ViewReviewModal onClose={() => setSelectedReview(null)} reviewId={selectedReview}/>
            </Modal>
        </MarketingWrap>
    );
};

export default ReviewsList;
